module.exports = __webpack_public_path__ + "img/服务费账单.f3b4584c.svg";